var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb',{staticClass:"px-4 bg-light pb-0",attrs:{"items":_vm.breadcrumbs}}),_c('div',{staticClass:"page-content"},[_c('PetcareSettings')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }